import type { FC } from 'react';

import { Typography } from '../../Typography';
import { theme } from '../../../styles/theme';

interface Props {
  message: string;
  items: string[];
  marginTop?: string | number;
}

export const ComparisonWarning: FC<Props> = ({ message, items, marginTop }) => {
  if (items.length === 0) return null;

  return (
    <div style={{ marginTop }}>
      <Typography variant={'p1'}>
        <strong>Warning:</strong> {message}
      </Typography>
      <ul style={{ marginTop: theme.spacing(2), marginBottom: 0 }}>
        {items.map(item => (
          <li key={item}>
            <code>{item}</code>
          </li>
        ))}
      </ul>
    </div>
  );
};
